
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-account/order/[orderStatusName]",
      function () {
        return require("private-next-pages/my-account/order/[orderStatusName].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-account/order/[orderStatusName]"])
      });
    }
  